import {CountUp} from 'countup.js';

class dday {
    constructor(opts) {
        this.opts = Object.assign({
            el: '#dday',
            dday: '2020-11-11T14:59:57'
        }, opts);
        this.time = {
            day: 0,
            hour: 0,
            minute: 0,
            second: 0
        }
        this.isOver = false;

        this.getTime();
    }

    getTime() {
        const dday = new Date(this.opts.dday).getTime();
        const now = new Date(`${serverTime.year}-${('0' + serverTime.monthOfYear).slice(-2)}-${('0' + serverTime.dayOfMonth).slice(-2)}T${('0' + serverTime.hourOfDay).slice(-2)}:${('0' + serverTime.minuteOfHour).slice(-2)}:${('0' + serverTime.secondOfMinute).slice(-2)}`).getTime();
        const distance = dday - now; //디데이에서 현재까지 뺀다.

        const d = Math.floor(distance / (1000 * 60 * 60 * 24)); //일
        const h = Math.floor((distance / (1000*60*60)) % 24); //시간
        const m = Math.floor((distance / (1000*60)) % 60); //분
        const s = Math.floor((distance / 1000) % 60); //초

        if (distance <= 0) {
            this.isOver = true;
        } else {
            this.time.day = d;
            this.time.hour = h;
            this.time.minute = m;
            this.time.second = s;
        }
    }

    countdown() {
        if(this.isOver) {
            $(this.opts.el).remove();
            return;
        }

        let d = this.time.day,
            h = this.time.hour,
            m = this.time.minute,
            s = this.time.second;

        let tempD = d,
            tempH = h,
            tempM = m,
            tempS = s - 4;
        if(tempS < 0) {
            tempS += 60;
            tempM--;
        }

        if(tempM < 0){
            tempM = 59;
            tempH--;
        }

        if(tempH < 0){
            tempH = 23;
            tempD--;
        }

        let countDay = new CountUp('dday-day', tempD, { startVal: 200, duration: 4.5 });
        let countHour = new CountUp('dday-hour', tempH, { startVal: 99, duration: 4.5 });
        let countMinute = new CountUp('dday-minute', tempM, { startVal: 99, duration: 4.5 });
        let countSecond = new CountUp('dday-second', tempS, { startVal: 99, duration: 4.5 });

        countDay.start();
        countHour.start();
        countMinute.start();
        countSecond.start();

        const timer = setInterval (() => {
            $(`${this.opts.el} .day`).html(d);
            $(`${this.opts.el} .hour`).html(h);
            $(`${this.opts.el} .minute`).html(m);
            $(`${this.opts.el} .second`).html(s);

            s--;
            if(s < 0){
                s = s + 60;
                m--;
            }

            if(m < 0){
                m = 59;
                h--;
            }

            if(h < 0){
                h = 23;
                d--;
            }

            if(d < 0) {
                clearInterval(timer);
                $(this.opts.el).remove();
            }
        }, 1000);
    }

    get day() {
        return this.time.day;
    }

    get hour() {
        return this.time.hour;
    }

    get minute() {
        return this.time.minute;
    }

    get second() {
        return this.time.second;
    }
}
export default dday;


// WEBPACK FOOTER //
// ./src/js/dday.js